import { StyledArrow, StyledTipLink } from './styled'
import { TipLinkProps } from './types'

const TipLink: React.FC<TipLinkProps> = ({
  target = '_blank',
  href = '#',
  indicator = true,
  children,
}) => {
  return (
    <StyledTipLink href={href} target={target}>
      {typeof children === 'string' ? <span> {children} </span> : children}
      {indicator && <StyledArrow />}
    </StyledTipLink>
  )
}

export default TipLink
